import React from "react";
import { Helmet } from "react-helmet";

import Dashboard from "../../../layouts/Dashboard";
import CalendarItemsList from "./CalendarItemsList";
import { CalendarItemSessionTypes } from "../Calendar.utils";

function EventList() {
  return (
    <>
      <Helmet>
        <title>Events</title>
      </Helmet>
      <Dashboard>
        <CalendarItemsList calendarItemType={CalendarItemSessionTypes.Events} />
      </Dashboard>
    </>
  );
}

export default EventList;
